import { assetsStore, editorStore } from '@/editor/store';

export interface RevealAssetInBrowserOptions {
  selectIfFound?: boolean;
}

function normalizeAssetPath(assetPath: string | null | undefined): string {
  const trimmedPath = assetPath?.trim() ?? '';
  if (!trimmedPath) {
    return '';
  }

  const normalizedSlashes = trimmedPath.replace(/\\/g, '/');
  return normalizedSlashes.startsWith('/@') ? normalizedSlashes.slice(1) : normalizedSlashes;
}

function getAssetDirectory(assetPath: string): string {
  const separatorIndex = assetPath.lastIndexOf('/');
  return separatorIndex >= 0 ? assetPath.slice(0, separatorIndex) : '';
}

/**
 * Reveals an asset path inside Asset Browser by navigating to its parent directory
 * and applying the standard highlighted-item style.
 */
export function showAssetInAssetBrowser(
  assetPath: string | null | undefined,
  options: RevealAssetInBrowserOptions = {}
): boolean {
  const normalizedPath = normalizeAssetPath(assetPath);
  if (!normalizedPath) {
    return false;
  }

  const { selectIfFound = false } = options;
  const targetDirectory = getAssetDirectory(normalizedPath);

  assetsStore.assetTree.setHighlightedItemPath(normalizedPath);
  assetsStore.setCurrentDirectory(targetDirectory);

  if (selectIfFound) {
    const targetAsset = assetsStore.assetTree.findFile(normalizedPath) ?? assetsStore.assetTree.findFolder(normalizedPath);
    if (targetAsset) {
      if (targetAsset.isFolder) {
        assetsStore.assetTree.setSelectedItem(targetAsset);
      } else {
        editorStore.setSelectedAssetItemByPath(normalizedPath);
      }
    }
  }

  return true;
}
